module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_FR-ebedda0557d8fd30cc51f1a542944cdb.svg";